
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navbar staticHeader={true} />
      </div>
      <main className="flex-grow pt-24 pb-16">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-3xl md:text-4xl font-bold mb-8 text-foreground">Privacy Policy</h1>
          <div className="prose prose-lg max-w-none">
            <p className="text-muted-foreground mb-6">Last Updated: April 30, 2025</p>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">Introduction</h2>
              <p className="mb-4">
                AuthorPro.ai ("we," "our," or "us") respects your privacy and is committed to protecting your personal data. 
                This privacy policy will inform you about how we look after your personal data when you visit our website and 
                tell you about your privacy rights and how the law protects you.
              </p>
              <p className="mb-4">
                This privacy policy applies to personal data we collect when you use our website, products, and services.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">Information We Collect</h2>
              <p className="mb-4">We may collect, use, store and transfer different kinds of personal data about you which we have grouped together as follows:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li><strong>Identity Data</strong> includes first name, last name, username or similar identifier.</li>
                <li><strong>Contact Data</strong> includes email address and telephone numbers.</li>
                <li><strong>Technical Data</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, browser plug-in types and versions, operating system and platform, and other technology on the devices you use to access this website.</li>
                <li><strong>Usage Data</strong> includes information about how you use our website, products, and services.</li>
                <li><strong>Marketing and Communications Data</strong> includes your preferences in receiving marketing from us and our third parties and your communication preferences.</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">How We Use Your Information</h2>
              <p className="mb-4">We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>To register you as a new customer.</li>
                <li>To deliver the products and services you've requested.</li>
                <li>To manage our relationship with you.</li>
                <li>To improve our website, products, and services.</li>
                <li>To recommend products or services that may interest you.</li>
                <li>To comply with legal obligations.</li>
              </ul>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">Disclosure of Your Information</h2>
              <p className="mb-4">We may share your personal data with the parties set out below:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Service providers acting as processors who provide IT and system administration services.</li>
                <li>Professional advisers including lawyers, bankers, auditors, and insurers.</li>
                <li>Regulators and other authorities who require reporting of processing activities in certain circumstances.</li>
              </ul>
              <p className="mb-4">
                We require all third parties to respect the security of your personal data and to treat it in accordance with the law. 
                We do not allow our third-party service providers to use your personal data for their own purposes and only permit 
                them to process your personal data for specified purposes and in accordance with our instructions.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">Data Security</h2>
              <p className="mb-4">
                We have put in place appropriate security measures to prevent your personal data from being accidentally lost, used, 
                or accessed in an unauthorized way, altered, or disclosed. In addition, we limit access to your personal data to those 
                employees, agents, contractors, and other third parties who have a business need to know.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">Your Legal Rights</h2>
              <p className="mb-4">Under certain circumstances, you have rights under data protection laws in relation to your personal data, including the right to:</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>Request access to your personal data.</li>
                <li>Request correction of your personal data.</li>
                <li>Request erasure of your personal data.</li>
                <li>Object to processing of your personal data.</li>
                <li>Request restriction of processing your personal data.</li>
                <li>Request transfer of your personal data.</li>
                <li>Right to withdraw consent.</li>
              </ul>
              <p className="mb-4">
                If you wish to exercise any of the rights set out above, please contact us at info@series-a.co.uk.
              </p>
            </section>
            
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-primary mb-4">Changes to This Privacy Policy</h2>
              <p className="mb-4">
                We may update our privacy policy from time to time. We will notify you of any changes by posting the new privacy 
                policy on this page and updating the "Last Updated" date at the top of this privacy policy.
              </p>
            </section>
            
            <section>
              <h2 className="text-2xl font-semibold text-primary mb-4">Contact Us</h2>
              <p className="mb-4">
                If you have any questions about this privacy policy or our privacy practices, please contact us at:
              </p>
              <p className="mb-4">
                Email: <a href="mailto:info@series-a.co.uk" className="text-gold hover:text-gold-light">info@series-a.co.uk</a>
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
